import { useContext } from 'react';
import { CategoriesContext } from '../../../App';
import MenuItem from './menu-item';
import Search from './elements/search';
import { Link, useNavigate } from 'react-router-dom';

function OniSidebar() {
    const { categories } = useContext(CategoriesContext);
    const nav = useNavigate();

    return (
        <div className="col-md-3">
            <div className="catalog-section-tree">
                <div className="catalog-section-tree__title">
                    <Link to="/" className="catalog-section-tree__title-link">
                        Каталог ONI
                    </Link>
                    <Search placeholder="Поиск по каталогу" onSearch={(q) => nav('/search/?q=' + q)} />
                </div>
                {categories.map((item) => (
                    <MenuItem key={item.slug} {...item} />
                ))}
            </div>
            <ul className="catalog-section-list section-list-bottom">
                <li>
                    <a href="/produktsiya/katalog-produktsii">Печатный каталог продукции</a>
                </li>
                <li>
                    <a href="/produktsiya/price">Прайс-лист</a>
                </li>
                <li>
                    <a href="/produktsiya/configurators/oni-equipment/">Конфигуратор подбора оборудования</a>
                </li>
            </ul>
        </div>
    );
}

export default OniSidebar;
